import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getWithFilterAction = () => {
  return StyleSheet.create({
    firstSectionItem: {
      marginTop: tokens.spacing.SPACING_8,
      marginBottom: tokens.spacing.SPACING_12
    },
    sectionItem: {
      marginTop: tokens.spacing.SPACING_24,
      marginBottom: tokens.spacing.SPACING_12
    },
    dividerStyle: {
      marginVertical: tokens.spacing.SPACING_8
    },
    dropDownFilterStyle: {
      position: 'absolute',
      top: tokens.spacing.SPACING_50,
      right: tokens.spacing.SPACING_5
    },
    filterWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  });
};